import { submitEvent, submitMerge, submitMove, trackOnNextPageImpression } from "@otto-ec/tracking-bct";
import { ModalTrackHelper } from "./modal_track_helper.js";

export class ModalTracking {
	constructor() {
		this.helper = new ModalTrackHelper();
	}

	sendLoadTrackingEvent(combo, articlesToTrack, isMoreArticlesLoaded, similarCombos, featureName = "SingleCombo") {
		submitMerge(
			{ ...(isMoreArticlesLoaded ? { promo_ShowMore: "loaded" } : {}) },
			this.helper._generateTrackingPayloadForCombo(combo, featureName, "loaded", articlesToTrack)
		);
		if (similarCombos) {
			this._sendSimilarCombosLoadTrackingEvent(similarCombos, combo.getComboType());
		}
	}

	sendClickArticleTrackingEvent(combo, articles, index, featureName = "SingleCombo") {
		const baseLevelTracking = {
			"wk.promo_AttributionFeature": this.helper._buildAttributionFeature(featureName, combo.getComboType()),
			"wk.promo_AttributionSource": combo.getSource(),
			promo_ComboType: combo.getComboType()
		};

		const articleCount = Number.parseInt(combo.getArticleCount());
		const status = "clicked";
		const comboTracking = this.helper._generateComboTracking(combo, featureName, status, articleCount);

		const featureTracking = {
			name: "click",
			features: [
				comboTracking,
				this.helper._generateTrackingPayloadForArticle(
					articles[index],
					combo.getArticleNumberFromADS(),
					comboTracking.id,
					featureName,
					status
				)
			]
		};

		submitMove(baseLevelTracking, featureTracking);
		trackOnNextPageImpression({ promo_Click: featureName });
	}

	sendMoreArticlesButtonClickEvent(combo, articlesToTrack, featureName = "SingleCombo") {
		const baseLevelTracking = {
			promo_ShowMore: "clicked"
		};

		const featureTracking = {
			name: "expand",
			features: this.helper._generateTrackingPayloadForCombo(combo, featureName, "loaded", articlesToTrack)
		};

		submitEvent(baseLevelTracking, featureTracking);
	}

	sendSimilarComboClickTrackingEvent(clickTrackingInfo, comboType) {
		const widgetPayload = this.helper._createWidgetPayloadWithNumberOfSimilarCombos(
			clickTrackingInfo.numberOfCombos,
			comboType,
			"clicked",
			2
		);

		const hasSimilarityScore = clickTrackingInfo.clickedCombo.similarityScore !== null;
		const featureName = "SimilarCombos";

		const clickedComboModalPayload = this.helper._generateClickedComboModalPayload(
			clickTrackingInfo,
			hasSimilarityScore
		);

		submitEvent(
			{
				ot_MessageType: "event",
				"wk.promo_AttributionFeature": this.helper._buildAttributionFeature("SimilarCombos", comboType),
				"wk.promo_AttributionSource": clickTrackingInfo.clickedCombo.comboSource
			},
			{
				name: "open",
				features: [widgetPayload, clickedComboModalPayload]
			}
		);
		trackOnNextPageImpression({ promo_Click: featureName });
	}

	_sendSimilarCombosLoadTrackingEvent(similarCombos, comboType) {
		const widgetPayload = this.helper._createWidgetPayloadWithNumberOfSimilarCombos(
			similarCombos.getTiles().length,
			comboType,
			"loaded",
			2
		);

		const combosPayload = this.helper._generatePageImpressionSimilarCombosPayload(similarCombos);

		const eventPayload = [widgetPayload].concat(combosPayload);
		submitMerge({}, eventPayload);
	}
}
